import React from 'react';
import { Stack } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';
import { PrincipalItem } from './principal-item/index.tsx';
import type { Props } from './types.tsx';

export const PrincipalList = ({ principals, removePrincipal }: Props) => {
	const { formatMessage } = useIntl();

	if (principals.length === 0) {
		return null;
	}

	return (
		<Stack
			space="space.050"
			testId="servicedesk-request-type-security.ui.config-button.config-modal.request-type-permissions-config.principal-list"
		>
			<PrincipalItem
				key="everyone-else"
				principal={{
					id: 'everyone-else',
					type: 'USER_GROUP',
					name: formatMessage(messages.everyoneElse),
				}}
				isGreyedOut
			/>
			{principals.map((principal) => (
				<PrincipalItem
					key={principal.id}
					principal={principal}
					canAccess
					removePrincipal={() => removePrincipal(principal.id)}
				/>
			))}
		</Stack>
	);
};
